import paths from "@icarius-router/paths";
import { periodComparator, periodFilterParams, periodFormatter, periodValueGetter } from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("evaluation"),
            field: "evaluation",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("evaluationYear"),
            field: "year",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("evaluationPeriod"),
            field: "period",
            filter: "agSetColumnFilter",
            comparator: periodComparator,
            filterParams: periodFilterParams(),
            valueFormatter: periodFormatter,
            valueGetter: periodValueGetter,
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("evaluationType"),
            field: "type",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("code"),
            field: "employeeCode",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "employeeName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("globalPerformanceAverage"),
            field: "performanceGlobalAverage",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("finalPerformanceScore"),
            field: "performanceFinalScore",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("performanceIndicator"),
            field: "indicatorPerformance",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: "IndicatorRenderer",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("finalPerformanceGrade"),
            field: "performanceFinalScoreName",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("maximumPossibleScore"),
            field: "maximumPossibleScore",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],

        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("ranking"),
            field: "ranking",
            filter: "agTextColumnFilter",
            cellRenderer: "ProgressRenderer",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("globalPerformanceAveragePotential"),
            field: "potentialGlobalAverage",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("finalPotentialScore"),
            field: "potentialFinalScore",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("potentialIndicator"),
            field: "indicatorPotential",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: "IndicatorRenderer",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("finalPotentialScoreAlternative"),
            field: "potentialFinalScoreName",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("quadrant"),
            field: "quadrantClassificationCode",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'NineBoxImageRenderer'
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("quadrantClassificationLong"),
            field: "quadrantName",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("management"),
            field: "management",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("department"),
            field: "department",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "costCenter",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("SHOW_DIVISION"),
            field: "division",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("category"),
            field: "category",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("position"),
            field: "position",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("function"),
            field: "function",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "workplace",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("sex"),
            field: "sex",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("age"),
            field: "age",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("ageGroup"),
            field: "ageGroup",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceAnalyticsHistoric],
        config: {
            headerName: getLocalizedString("directBoss"),
            field: "boss",
            filter: "agSetColumnFilter",
        }
    },
]